import { UITab, UIMenuItem } from '@constants';
import { useCheckScreenWithCallback } from '@hooks';
import React, { memo, useState, useCallback, useRef, useMemo } from 'react';
import trans from 'translation';
import { KContainer, KTab, KTabInstance } from 'uikit';

import Allocation from './components/Allocation';
import Notifications from './components/Notifications';
import Notifications1Stop from './components/Notifications1Stop';

const CombinedNotifications = () => {
  const tabRef = useRef<KTabInstance>(null);
  const cb = useCallback(() => {
    let _tabs = [
      {
        code: UITab.Notification,
        label: trans('notification')
      },
      {
        code: UITab.Notification1Stop,
        label: trans('1_stop_containerchain')
      },
      {
        code: UITab.Pod,
        label: trans('pod')
      }
    ];

    return _tabs;
  }, []);

  const [tabIndex, setTabIndex] = useState(0);

  const tabs = useCheckScreenWithCallback(cb, UIMenuItem.Operation);

  const content = useMemo(
    () => (
      <KTab.White
        ref={tabRef}
        tabIndex={tabIndex}
        onChangeTab={setTabIndex}
        tabs={tabs}
      />
    ),
    [tabIndex, tabs]
  );

  return (
    <KContainer.Card
      marginT={0}
      dp="flex"
      overflow="hidden"
      alignItems="stretch"
      flexG={1}
      height={'100%'}
      // minH={DASHBOARD_CONTENT_HEIGHT - 12 * 2}
      // maxH={DASHBOARD_CONTENT_HEIGHT - 12 * 2}
      header={{
        content
      }}
    >
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.Notification)}
      >
        <Notifications />
      </KTab.Panel>
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.Notification1Stop)}
      >
        <Notifications1Stop />
      </KTab.Panel>
      <KTab.Panel
        value={tabIndex}
        index={tabs.findIndex(i => i.code === UITab.Pod)}
      >
        <Allocation />
      </KTab.Panel>
    </KContainer.Card>
  );
};

export default memo(CombinedNotifications);
